































































import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class Top extends Vue {
  /** data */
  /** emit */
  /** watch */
  /** computed */
  /** lifecycle hook */
  /** methods */
}
